import React from "react";

export const SeparatorMenu = () => {
  return (
    <div>
      <hr />
    </div>
  );
};
